"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _CalendarContext = _interopRequireDefault(require("./CalendarContext"));

var useCls = function useCls() {
  var _useContext = (0, _react.useContext)(_CalendarContext.default),
      prefixCls = _useContext.prefixCls;

  var cls = (0, _react.useMemo)(function () {
    return {
      table: prefixCls + '-table',
      head: prefixCls + '-thead',
      row: prefixCls + '-row',
      cell: prefixCls + '-cell',
      active: prefixCls + '-active',
      now: prefixCls + '-now',
      disabled: prefixCls + '-disabled',
      prev: prefixCls + '-prev',
      next: prefixCls + '-next',
      rangeFirst: prefixCls + '-range-first',
      rangeLast: prefixCls + '-range-last',
      rangeMiddle: prefixCls + '-range-middle',
      rangeUnclosed: prefixCls + '-range-unclosed',
      wrap: prefixCls,
      month: prefixCls + '-month',
      monthWrap: prefixCls + '-month-wrap',
      body: prefixCls + '-body'
    };
  }, [prefixCls]);
  return cls;
};

var _default = useCls;
exports.default = _default;